import { useContext, useState, useEffect } from 'react';
import { ShopContext } from '../context/ShopContext';
import { useParams } from 'react-router-dom';
import { FaMinus, FaPlus } from "react-icons/fa6";
import config from '../config';
import { useDispatch } from 'react-redux';
import { addToCart } from '../store/cartSlice';
import { useSelector } from 'react-redux';

const SubCategoryProductItem = ({ productAbout, campaignProduct }) => {
  // const { products, currency, addToCart } = useContext(ShopContext);
  const products = useSelector(state => state.shop.products);
  const currency = useSelector(state => state.shop.currency);
  const { productId } = useParams();
  const dispatch = useDispatch();

  const [mainProductType, setMainProductType] = useState("");
  const [showFormModal, setShowFormModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [message, setMessage] = useState("");
  const [deliveryDate, setDeliveryDate] = useState("");

  const [quantities, setQuantities] = useState({});

  // Features
  const [featureRecipient1, setFeatureRecipient1] = useState(false);
  const [featureRecipient2, setFeatureRecipient2] = useState(false);
  const [featureRecipient3, setFeatureRecipient3] = useState(false);
  const [featureRecipient4, setFeatureRecipient4] = useState(false);
  const [featureRecipient5, setFeatureRecipient5] = useState(false);

  useEffect(() => {
    const mainSubproduct = products.find(product => product.id === productId);
    if (mainSubproduct) {
      setMainProductType(mainSubproduct.type || "");
    }

    // Set initial quantities from campaignProduct
    const initialQuantities = {};
    campaignProduct.forEach(product => {
      initialQuantities[product.id] = product.minimum_quantity || 1;
    });
    setQuantities(initialQuantities);
  }, [productId, products, campaignProduct]);

  const incrementQuantity = (id, step) => {
    setQuantities(prev => ({
      ...prev,
      [id]: (prev[id] || step) + step,
    }));
  };

  const decrementQuantity = (id, step) => {
    setQuantities(prev => {
      const current = prev[id] || step;
      const newValue = current - step;
      return {
        ...prev,
        [id]: newValue < step ? step : newValue,
      };
    });
  };

  const openFormModal = (product) => {
    setSelectedProduct(product);
    setShowFormModal(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const quantity = quantities[selectedProduct.id] || selectedProduct.minimum_quantity || 1;

    const cartPayload = {
      id: selectedProduct.id,
      name: selectedProduct.name,
      price: selectedProduct.price,
      thumbnail_imge: selectedProduct.thumbnail_imge,
      quantity: quantity,

      // Optional extras — include if you plan to use these in checkout or summary
      message: message,
      deliveryDate: deliveryDate,
      features: {
        featureRecipient1,
        featureRecipient2,
        featureRecipient3,
        featureRecipient4,
        featureRecipient5
      }
    };
    
    dispatch(addToCart(cartPayload));
    setShowFormModal(false);
  };
  
  return (
    <div className="container">
      <div className="row gy-4 gy-xl-0 gx-xl-5 my-5">
        {campaignProduct.map((product) => {
          const quantity = quantities[product.id] || product.minimum_quantity || 1;

          return (
            <div key={product.id} className="col-md-6 col-xl-4 mb-4">
              <div className="product_wrapper h-100 overflow-hidden">
                <div className="product_img text-center">
                  <div className="ratio ratio-16x9">
                    <img
                      src={product.thumbnail_imge}
                      alt={product.name}
                      className="img-fluid"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = config.defaultImage;
                      }}
                    />
                    {/* <iframe className="w-100" src={campaingnProductData.videoLink} title={campaingnProductData.name} frameBorder="0" allowFullScreen></iframe> */}
                  </div>
                </div>
                <div className="product_content p-2 p-md-4">
                  <h4><a href="#">{product.name}</a></h4>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="price">{currency}{product.price}/ Unit</div>
                    <div className="qty_groups text-center">
                      <button type="button" className="qty_minus" onClick={() => decrementQuantity(product.id, product.minimum_quantity)}>
                        <FaMinus />
                      </button>
                      <input type="number" name="qty" readOnly value={quantity} min={product.minimum_quantity} />
                      <button type="button" className="qty_plus" onClick={() => incrementQuantity(product.id, product.minimum_quantity)}>
                        <FaPlus />
                      </button> 
                    </div>
                  </div>
                  <div className="desc mb-3 mt-4">{product.description}</div>
                  <div className="mt-auto">
                    <button
                      className="btn btn-outline-dark w-100 text-uppercase"
                      onClick={() => openFormModal(product)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Modal for Form Submission */}
      {showFormModal && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="donationModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-xl">
            <div className="modal-content p-3 p-xl-5">
              <div className="modal-header border-0">
                <button type="button" className="btn-close" onClick={() => setShowFormModal(false)} aria-label="Close"></button>
              </div>
              <div className="modal-body p-0">
                <h5 className="">Make An Unforgettable Donation</h5>
                <div className="row gy-4 gy-xl-0">
                  <div className="col-xl-6">
                    <div className="megs-box h-100">
                      <div className="box-1 d-sm-flex justify-content-between mb-3 w-100">
                        <p>Name to be printed </p>
                        <button className="bg-transparent demo">Demo</button>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name to be printed "
                        maxLength="50"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="megs-box d-flex h-100">


                      <div className="box-1 mb-3">
                        <p className="mb-2">Delivery Date</p>
                        <input
                          className="form-control"
                          type="date"
                          value={deliveryDate}
                          onChange={(e) => setDeliveryDate(e.target.value)}
                          required
                        />
                        <span>The updates will be available by 8:00 PM on a scheduled date. Please choose a suitable date</span>
                      </div>
                    </div>
                  </div>
                  <div className="features-part poup-formgg col-xl-12">
                    <h6 className="mb-2 clss">* You Can Only Do Special Request Above ₹ 700</h6>
                    {/* Checkbox and Input for Recipient Name 1 */}
                    <div className="box-items check-box-sz d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <h6 className='mb-2'>Do you want attach picture on food packet ? </h6>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="recipient1"
                          checked={featureRecipient1}
                          onChange={() => setFeatureRecipient1(!featureRecipient1)}
                        />
                      </div>
                    </div>
                    {featureRecipient1 && (
                      <form className="border p-2">
                        <div className="mb-2">
                          <label>
                            Add Your Customized Photo or image to the food parcel, This can be anything from your loved one's Photo or your organisations Logo, The choice is up to you,See the Example.:
                          </label>
                          <input
                            type="file"
                            maxLength="50"
                            placeholder="Type here..."
                            className="form-control"
                          />
                        </div>
                      </form>
                    )}

                    {/* Checkbox and Input for Recipient Name 2 */}
                    <div className="box-items check-box-sz d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center">
                        <h6 className='mb-2'>Need a Video Wishes ?</h6>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="recipient2"
                          checked={featureRecipient2}
                          onChange={() => setFeatureRecipient2(!featureRecipient2)}
                        />
                      </div>
                    </div>
                    {featureRecipient2 && (
                      <form className="border p-2">
                        <div className="mb-2">

                          <input
                            type="text"
                            maxLength="50"
                            placeholder="We'll create a video with beneficiaries saying your message. Mention your message here within 15 words."
                            className="form-control"
                          />
                        </div>
                      </form>
                    )}

                    {/* Checkbox and Input for Recipient Name 3 */}
                    <div className="colass">
                      <h6> Any Special Request?</h6>
                      <span>We would try our best to consider them</span>
                    </div>

                    <div className="box-items check-box-sz d-flex justify-content-between align-items-center">

                      <div className="d-flex align-items-center">
                        <h6 className='mb-2'>Is this a gift or on behalf of someone else?</h6>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="recipient3"
                          checked={featureRecipient3}
                          onChange={() => setFeatureRecipient3(!featureRecipient3)}
                        />
                      </div>
                    </div>
                    {featureRecipient3 && (
                      <form className="border p-2">
                        <div className="mb-2">
                          <label>
                            Recipient's Name *
                          </label>
                          <input
                            type="text"
                            maxLength="50"
                            placeholder="Type here..."
                            className="form-control"
                          />
                          <label>
                            Phone Name *
                          </label>
                          <input
                            type="number"
                            maxLength="50"
                            placeholder="Type here..."
                            className="form-control"
                          />
                        </div>
                      </form>
                    )}

                    {/* Checkbox and Input for Recipient Name 4 */}


                    <div className="box-items check-box-sz d-flex justify-content-between align-items-center">

                      <div className="d-flex align-items-center">
                        <h6 className='mb-2'>Tag you on our instagram ?</h6>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="recipient3"
                          checked={featureRecipient4}
                          onChange={() => setFeatureRecipient4(!featureRecipient4)}
                        />
                      </div>
                    </div>
                    {featureRecipient4 && (
                      <form className="border p-2">
                        <div className="mb-2">
                          <label>
                            Recipient's Name *
                          </label>
                          <input
                            type="text"
                            maxLength="50"
                            placeholder="Instagram id to tag *"
                            className="form-control"
                          />

                        </div>
                      </form>
                    )}

                    {/* Checkbox and Input for Recipient Name 4 */}


                    <div className="box-items check-box-sz d-flex justify-content-between align-items-center">

                      <div className="d-flex align-items-center">
                        <h6 className='mb-2'> Any Other Request?</h6>
                      </div>
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="recipient3"
                          checked={featureRecipient5}
                          onChange={() => setFeatureRecipient5(!featureRecipient5)}
                        />
                      </div>
                    </div>
                    {featureRecipient5 && (
                      <form className="border p-2">
                        <div className="mb-2">

                          <input
                            type="text"
                            maxLength="50"
                            placeholder="Message *"
                            className="form-control"
                          />

                        </div>
                      </form>
                    )}
                  </div>

                </div>
                <div className="modal-footer border-0 p-0 mt-5 d-flex justify-content-between">
                  <button type="button" className="btn btn-primary skip-btn" onClick={() => setShowFormModal(false)}>SKIP</button>
                  <button type="button" className="btn btn-primary add-to-cart-btn" onClick={handleSubmit}>
                    Add to Cart
                    <span>Message to be printed required!</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="campaign_content dropdown-button-ss">
        <h4>About Campaign</h4>
        <div dangerouslySetInnerHTML={{ __html: productAbout }} />
      </div>

    </div>
  );
};

export default SubCategoryProductItem;
